import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { type Route } from "@route-types/Section/layouts/Lifestyle/+types/LifestylePage";
import { fetchLifestyleData } from "@routes/Section/layouts/Lifestyle/LifestylePage.server";
import LifestylePageContent from "@routes/Section/layouts/Lifestyle/LifestylePageContent";
import { LifestyleContext } from "@routes/Section/layouts/Lifestyle/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

const LifestylePage = (): React.ReactElement => {
  const context = useLoaderData<LifestyleContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  const { data } = context.payload;

  return <LifestylePageContent {...data} gaProps={context.payload.gaProps} />;
};

export default LifestylePage;

export const loader = async () => await fetchLifestyleData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as LifestyleContext;

  if (context.type !== ResponseType.SUCCESS) return [];
  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
